import Api from '@/services/Api'

export default {
  checkFeeling(data) {
    return Api().get(`users/me/videos/${data.videoId}/rating`, data)
  },
  createFeeling(data) {
   // console.log(data);
    return Api().put(`videos/${data.videoId}/rate`, data)
  },
  getLikedVideos(page) {
    return Api().get('feelings/videos', {
      params: {
        page,
        limit: 12
      }
    })
  }
}
